export const LOAN_ACTION_VARIANT_OPTIONS = [
  { name: 'Outlined', value: 'outlined' },
  { name: 'Contained', value: 'contained' },
];

export const DEFAULT_LOAN_ACTION_VARIANT = 'outlined';

export const LoanActionTargetType = {
  APPLICATION: 'Application',
  CONTACT: 'Contact',
  SUB_COMPANY: 'SubCompany',
};

export const DEFAULT_LOAN_ACTION_TARGET_TYPE = LoanActionTargetType.APPLICATION;

export const loanActionTargetTypeOptions = [
  { label: 'Application', value: LoanActionTargetType.APPLICATION },
  { label: 'Contact', value: LoanActionTargetType.CONTACT },
  { label: 'Sub-Company', value: LoanActionTargetType.SUB_COMPANY },
];
